export const loadGoogleMapsAPI = () => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
      console.error("Google Maps API Key is missing. Please check your .env file.");
      return Promise.reject("Google Maps API Key is missing.");
  }

  // Check if the script is already added
  if (document.querySelector(`script[src*="maps.googleapis.com"]`)) {
      return Promise.resolve(); // Script already loaded
  }

  return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
          console.log("Google Maps API script loaded successfully.");
          resolve();
      };

      script.onerror = (error) => {
          console.error("Error loading Google Maps API script:", error);
          reject(error);
      };

      document.head.appendChild(script);
  });
};